!(function () {
  "use strict";
  var e = {
      4105: function (e, t, r) {
        r.d(t, {
          Ds: function () {
            return n;
          },
          Q2: function () {
            return c;
          },
        });
        const c = function () {
          let e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "json";
          return {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: `application/${e}`,
            },
          };
        };
        function n(e, t) {
          var r,
            c = this;
          return function () {
            for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
              i[a] = arguments[a];
            clearTimeout(r),
              (r = setTimeout(function () {
                return e.apply(c, i);
              }, t));
          };
        }
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
            const t = e.target.getAttribute("href");
            ((e) => {
              Math.easeInOutQuad = function (e, t, r, c) {
                return (e /= c / 2) < 1
                  ? (r / 2) * e * e + t
                  : (-r / 2) * (--e * (e - 2) - 1) + t;
              };
              const t = document.getElementById("grid-archive-header"),
                r = document.getElementById("nav-wrapper");
              let c = 0;
              t && (c = t.offsetHeight + 50),
                r && (navWrapperOffset = r.offsetHeight + 50);
              const n = e.offsetTop - c - navWrapperOffset,
                i = window.scrollY,
                a = n - i;
              let o = 0;
              const l = () => {
                o += 5;
                const e = Math.easeInOutQuad(o, i, a, 200);
                window.scrollTo(0, e), o < 200 && setTimeout(l, 5);
              };
              l();
            })(document.querySelector(t));
          });
        });
      },
    },
    t = {};
  function r(c) {
    var n = t[c];
    if (void 0 !== n) return n.exports;
    var i = (t[c] = { exports: {} });
    return e[c](i, i.exports, r), i.exports;
  }
  (r.d = function (e, t) {
    for (var c in t)
      r.o(t, c) &&
        !r.o(e, c) &&
        Object.defineProperty(e, c, { enumerable: !0, get: t[c] });
  }),
    (r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      var e = r(4105);
      const t = document.getElementById("main-cart");
      var c = c || {};
      (c.money_format = "${{amount}}"),
        (c.formatMoney = function (e, t) {
          "string" == typeof e && (e = e.replace(".", ""));
          var r = "",
            c = /\{\{\s*(\w+)\s*\}\}/,
            n = t || this.money_format;
          function i(e, t) {
            return void 0 === e ? t : e;
          }
          function a(e, t, r, c) {
            if (
              ((t = i(t, 2)),
              (r = i(r, ",")),
              (c = i(c, ".")),
              isNaN(e) || null == e)
            )
              return 0;
            var n = (e = (e / 100).toFixed(t)).split(".");
            return (
              n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r) +
              (n[1] ? c + n[1] : "")
            );
          }
          switch (n.match(c)[1]) {
            case "amount":
              r = a(e, 2);
              break;
            case "amount_no_decimals":
              r = a(e, 0);
              break;
            case "amount_with_comma_separator":
              r = a(e, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              r = a(e, 0, ".", ",");
          }
          return n.replace(c, r);
        });
      const n = (e) => {
          const r = e.items;
          if (r.length > 0) {
            (document.querySelector(".cart__wrapper").style.display = "grid"),
              (document.querySelector(".cart__empty").style.display = "none");
            const n = document.getElementById("cart-total-price");
            document
              .querySelectorAll(".cart-count")
              .forEach((t) => (t.textContent = e.item_count));
            let i = e.items_subtotal_price / 100;
            n.innerText = c.formatMoney(e.items_subtotal_price, `${currency}{{amount}}`);
            let a = document.createElement("div");
            a.classList.add("cart-items__container"),
              r.forEach((e) => {
                let t = document
                    .querySelector(".empty-cart-item > .cart-item.mobile")
                    .cloneNode(!0),
                  r = document
                    .querySelector(".empty-cart-item > .cart-item.desktop")
                    .cloneNode(!0);
                t.setAttribute("data-variant-id", e.variant_id),
                  r.setAttribute("data-variant-id", e.variant_id),
                  (t.querySelector(".cart-item__title").innerText = e.title),
                  (r.querySelector(".cart-item__title a").innerText = e.title),
                  t
                    .querySelector(".cart-item__title")
                    .setAttribute("href", e.url),
                  r
                    .querySelector(".cart-item__title a")
                    .setAttribute("href", e.url),
                  (t.querySelector('input[name="quantity"]').value =
                    e.quantity),
                  (r.querySelector('input[name="quantity"]').value =
                    e.quantity),
                  e.featured_image.url
                    ? (t
                        .querySelector(".cart-item-image")
                        .setAttribute("src", e.featured_image.url),
                      r
                        .querySelector(".cart-item__image img")
                        .setAttribute("src", e.featured_image.url))
                    : ((t.querySelector(".cart-item__image figure").innerHTML =
                        '<svg class="img-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"/><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"/><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"/><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"/></svg>'),
                      (r.querySelector(".cart-item__image figure").innerHTML =
                        '<svg class="img-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"/><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"/><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"/><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"/></svg>')),
                  e.selling_plan_allocation &&
                    ((r.querySelector(".cart-item__selling-plan").innerText =
                      e.selling_plan_allocation.selling_plan.name),
                    (t.querySelector(".cart-item__selling-plan").innerText =
                      e.selling_plan_allocation.selling_plan.name));
                const n = e.discounts;
                if (
                  (n &&
                    n.length > 0 &&
                    n.forEach((e) => {
                      r.querySelector(".cart-item__discounts").innerHTML =
                        "<li><span class='icon loaded'>sell</span>" +
                        e.title +
                        "</li>";
                    }),
                  e.properties)
                ) {
                  const c = Object.entries(e.properties);
                  r
                    .querySelector(".cart-item__properties")
                    .classList.remove("u-hide"),
                    t
                      .querySelector(".cart-item__properties")
                      .classList.remove("u-hide"),
                    c.forEach((e) => {
                      e[0].startsWith("_") ||
                        "" == e[1] ||
                        ((r.querySelector(".cart-item__properties").innerHTML +=
                          "<p class='text-xs'><strong>" +
                          e[0] +
                          "</strong>: " +
                          e[1] +
                          "</p>"),
                        (t.querySelector(".cart-item__properties").innerHTML +=
                          "<p class='text-xs'><strong>" +
                          e[0] +
                          "</strong>: " +
                          e[1] +
                          "</p>"));
                    });
                }
                const o = e.unit_price;
                o &&
                  ((r.querySelector(
                    ".cart-item__totals span.unit-price"
                  ).innerText = c.formatMoney(o, `${currency}{{amount}}`)),
                  (r.querySelector(
                    ".cart-item__totals span.unit-price-reference-value"
                  ).innerText = ` / ${e.unit_price_measurement.reference_value}`),
                  (r.querySelector(
                    ".cart-item__totals span.unit-price-reference-unit"
                  ).innerText = `${e.unit_price_measurement.reference_unit}`),
                  (t.querySelector(
                    ".cart-item__totals span.unit-price"
                  ).innerText = c.formatMoney(o, `${currency}{{amount}}`)),
                  (t.querySelector(
                    ".cart-item__totals span.unit-price-reference-value"
                  ).innerText = ` / ${e.unit_price_measurement.reference_value}`),
                  (t.querySelector(
                    ".cart-item__totals span.unit-price-reference-unit"
                  ).innerText = `${e.unit_price_measurement.reference_unit}`));
                var l = 0;
                fetch("/products/" + e.handle + ".js")
                  .then((e) => e.json())
                  .then((t) =>
                    (function (t) {
                      const r = t.variants,
                        n = e.variant_id,
                        i = document
                          .querySelector(
                            '.cart-item.desktop[data-variant-id="' + n + '"]'
                          )
                          .querySelector(".cart-item__unit-price");
                      r.forEach((t) => {
                        t.id == n &&
                          (t.compare_at_price > 0
                            ? ((l = t.compare_at_price),
                              (i.innerHTML =
                                "<s>" +
                                c.formatMoney(l, `${currency}{{amount}}`) +
                                "</s>" +
                                c.formatMoney(
                                  e.price,
                                  `${currency}{{amount}}`
                                )))
                            : e.original_price > e.final_price
                            ? (i.innerHTML =
                                "<s>" +
                                c.formatMoney(
                                  e.original_price,
                                  `${currency}{{amount}}`
                                ) +
                                "</s>" +
                                c.formatMoney(
                                  e.final_price,
                                  `${currency}{{amount}}`
                                ))
                            : (i.innerHTML = c.formatMoney(
                                e.price,
                                `${currency}{{amount}}`
                              )));
                      });
                    })(t)
                  );
                const u = t.querySelector(".cart-item-subtotal"),
                  s = r.querySelector(".cart-item__totals span.total-price");
                (u.innerText = c.formatMoney(
                  e.final_line_price,
                  `${currency}{{amount}}`
                )),
                  (s.innerText = c.formatMoney(
                    e.final_line_price,
                    `${currency}{{amount}}`
                  )),
                  a.appendChild(t),
                  a.appendChild(r);
              }),
              (t.querySelector(".cart-items__container").innerHTML =
                a.innerHTML),
              t
                .querySelectorAll(".cart-items__container .cart-item")
                .forEach((e, t) => {
                  const c = e.getAttribute("data-variant-id");
                  (e.querySelector('input[name="quantity"]').value = r.find(
                    (e) => e.variant_id === parseInt(c)
                  ).quantity),
                    o(e);
                });
          // Check if currency conversion should be applied based on theme setting
          const shouldConvertCurrency = window.theme_settings?.enable_currency_conversion === true;

          // Calculate threshold based on the toggle
          let adjustedThreshold;
          if (shouldConvertCurrency && window.Shopify?.currency?.rate) {
            // Apply currency conversion
            adjustedThreshold = freeShippingThreshold * window.Shopify.currency.rate;
          } else {
            // Use original threshold without conversion
            adjustedThreshold = freeShippingThreshold;
          }

          const l = adjustedThreshold - i;

          t.querySelector(".free-shipping-left") &&
            ((t.querySelector(
              ".free-shipping-left > #amount-left"
            ).innerText = currency + l.toFixed(2)),
            t
              .querySelector(".free-shipping-left")
              .setAttribute(
                "data-percentage",
                adjustedThreshold <= i
                  ? 100
                  : 100 *
                      (
                        l /
                        adjustedThreshold
                      ).toFixed(2)
              ),
            adjustedThreshold <= i
              ? ((t.querySelector(".free-shipping-left").style.display =
                  "none"),
                (t.querySelector(".free-shipping-qualified").style.display =
                  "block"))
              : ((t.querySelector(".free-shipping-left").style.display =
                  "block"),
                (t.querySelector(".free-shipping-qualified").style.display =
                  "none"))),
            document.body.classList.add("active", "addtocart"),
            window.setTimeout(
              () => document.body.classList.remove("active", "addtocart"),
              2e3
            );
          } else
            (document.querySelector(".cart__wrapper").style.display = "none"),
              (document.querySelector(".cart__empty").style.display = "block");
        },
        i = () => {
          fetch("/cart.js")
            .then((e) => e.json())
            .then((e) => {
              n(e);
            });
        };
      new MutationObserver(function (e, t) {
        e.forEach(function (e) {
          "attributes" === e.type && "class" === e.attributeName && i();
        });
      }).observe(t, { attributes: !0 });
      const a = (t) => {
          const r = JSON.stringify(t);
          fetch(`${routes.cartChange}`, { ...(0, e.Q2)(), body: r })
            .then((e) => e.json())
            .then(function (e) {
              n(e),
                t.quantity > e.item_count &&
                  ((document.querySelector(
                    '.cart-item.desktop[data-variant-id="' +
                      e.items[0].id +
                      '"] .cart-item__error'
                  ).innerHTML = window.cartStrings.quantityError.replace(
                    "[quantity]",
                    e.item_count
                  )),
                  (document.querySelector(
                    '.cart-item.mobile[data-variant-id="' +
                      e.items[0].id +
                      '"] .cart-item__error'
                  ).innerHTML = window.cartStrings.quantityError.replace(
                    "[quantity]",
                    e.item_count
                  )));
            })
            .catch((e) => {
              console.error("Error:", e);
            });
        },
        o = (e) => {
          const t = e.getAttribute("data-variant-id"),
            r = e.querySelector('input[name="quantity"]'),
            c = e.querySelector(".cart-item-delete, .cart-item__remove");
          let n = parseInt(r.value);
          const i = e.querySelector('.quantity button[name="plus"]'),
            o = e.querySelector('.quantity button[name="minus"]');
          i.addEventListener("click", function () {
            (n += 1), (r.value = n), a({ id: t, quantity: n });
          }),
            o.addEventListener("click", function () {
              (n -= 1), (r.value = n), a({ id: t, quantity: n });
            }),
            c.addEventListener("click", function () {
              a({ id: t, quantity: 0 }), e.remove();
            });
        };
      t.querySelectorAll(".cart-item").forEach((e) => {
        o(e);
      }),
        i(),
        customElements.get("cart-note") ||
          customElements.define(
            "cart-note",
            class extends HTMLElement {
              constructor() {
                super(),
                  this.addEventListener(
                    "change",
                    (0, e.Ds)((t) => {
                      const r = JSON.stringify({ note: t.target.value });
                      fetch(`${routes.cart_update_url}`, {
                        ...(0, e.Q2)(),
                        body: r,
                      });
                    }, 300)
                  );
              }
            }
          );
    })();
})();
